module.exports = __webpack_public_path__ + "src/img/stopWatch/a5559aa1ce070df74d52b2fed0815402.png";